import React from 'react';
import { AlertIcon } from 'assests/GmsIcons';

type TABToast = {
    msg1?: string;
    msg2: string;
}

const ABToast = ({ msg1, msg2 }: TABToast) => {
    return (
        <div className="tw-flex tw-items-center tw-justify-center ">
            <div className="tw-h-11  tw-mt-4 tw-w-auto tw-px-4 tw-bg-[#fffae6] tw-rounded tw-border tw-border-[#ffc400] tw-gap-2.5 tw-items-center  tw-inline-flex">
                <div className="tw-w-6 tw-h-6 tw-relative"><AlertIcon /></div>
                <span className="tw-text-black tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight">{msg1}</span>
                <span className="tw-text-black tw-text-sm tw-leading-tight"> {msg2}</span>
            </div>
        </div>);
}

export default ABToast;